import { applyMiddleware, CombinedState, combineReducers, compose, createStore as _createStore } from 'redux';
import thunk from 'redux-thunk';

import { chatModalReducer, isRenterFormEnabledReducer, recommendationsReducer, userReducer } from '../../reducers';
import { IApplicationContext } from '../../types/applicationContext';
import { IApplicationState, TReduxActions, IReduxStore, TThunkDispatch } from '../../types/redux';
import { notAvailableModalReducer } from '../../reducers/notAvailableModal';
import { analyticsReducer } from '../../reducers/analytics';
import { experimentsReducer } from '../../reducers/experiments';
import { pageTypeSourceReducer } from '../../reducers/pageTypeSource';

interface IThunkExt {
  dispatch: TThunkDispatch;
}

let storeReminder: IReduxStore;

/**
 * Хелпер для создания Redux стора
 * @param initialState IApplicationState - предзагруженное состояние
 */
export function createReduxStore(context: IApplicationContext, initialState: IApplicationState, debugEnabled: boolean) {
  const reducers = combineReducers<IApplicationState, TReduxActions>({
    recommendations: recommendationsReducer,
    user: userReducer,
    isRenterFormEnabled: isRenterFormEnabledReducer,
    chatModal: chatModalReducer,
    notAvailableModal: notAvailableModalReducer,
    analytics: analyticsReducer,
    experiments: experimentsReducer,
    pageTypeSource: pageTypeSourceReducer,
  });

  const composeEnhancers = debugEnabled ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;

  const storeEnchancers = composeEnhancers(applyMiddleware(thunk.withExtraArgument(context)));

  const createStore = (): IReduxStore =>
    _createStore<CombinedState<IApplicationState>, TReduxActions, IThunkExt, {}>(
      reducers,
      initialState,
      storeEnchancers,
    );

  if (process.env.NODE_ENV === 'development' && debugEnabled) {
    if (!storeReminder) {
      storeReminder = createStore();
    }

    storeReminder.replaceReducer(reducers);

    return storeReminder;
  }

  return createStore();
}
